<template>
  <div class="home">
    <div class="imgbox">
      <!-- 最外层div设置为绝对定位 -->
      <div style="position: absolute;">
        <img class="box-img" src="../assets/banner3.png">
        <div class="box-font">下载专区</div>
      </div>
    </div>
      <article class="newhome" v-cloak  style="padding-bottom: 100px;">
      <div style="display: flex;margin-top: 40px;">
        <div>
          <leftmenu :value='Category' :list='down_typelist' @datashow =tableshow ></leftmenu>
        <!--登录-->
        
        </div>
      <div class="ml-border">
        <el-table
              :data="this.downloadlist"
              height="750"
              style="width: 100%;font-size: 18px;padding-left:20px"
              :row-style="{}"
              :cell-style="{'font-size': '16px','padding':'20px 0px'}"
              :header-row-style="{}"
              :fit="true"
            >
              <el-table-column
                prop="Title"
                label="标题"
                width="410"
              >
              </el-table-column>
              <el-table-column
                prop="CreateTime"
                label="发布时间"
                width="280"
              >
              </el-table-column>
              <el-table-column
                prop=""
                label="操作"
                width="250"
              >
                <template slot-scope="scope">
                  <a @click="Down(scope.row.Id)" style="color:red" >下载
                  </a>
                </template>
      
              </el-table-column>
        </el-table>
      </div>
      </div> 
      <div class="pagination">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="[10, 15, 20]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
          </el-pagination>
        </div>     
    </article>
  </div>
</template>
<script>
import leftmenu from "../components/leftmenu.vue";
export default {
  name: "Download",
  components: { leftmenu },
  data: function() {
    return {
      Category: '',
      down_typelist: [],
      downloadlist: [],
      currentPage:1,
      pagesize:10,
      total:0
    };
  },
  updated() {
  },
  created() {    
    var that =this;
    that.Category = that.$route.query.id;
    var menulist = JSON.parse(window.localStorage.getItem("menulist")) || [];    
    that.down_typelist = menulist.filter(function(item){
            return item.Word_Group_Key == 'DownloadType'
    });
    if(!that.Category) that.getData();
    else {
      var list = that.down_typelist.filter(function(item){
          return item.Word_Value == that.Category
      });
      if(list.length > 0){
        that.getData();    
      }
      
    }
  },
  watch: {
    $route: async function(to, from) {
      var that =this;
      that.Category = to.query.id;
      var menulist = JSON.parse(window.localStorage.getItem("menulist")) || [];    
      that.down_typelist = menulist.filter(function(item){
              return item.Word_Group_Key == 'DownloadType'
      });
      if(!that.Category) that.getData();
      else {
        var list = that.down_typelist.filter(function(item){
            return item.Word_Value == that.Category
        });
        if(list.length > 0){
          that.getData();    
        }
        
      }
    }
  },
  mounted() {
     
  },
  methods: {       
    getData() {
      var that = this;
      var params = {
        PageIndex : that.currentPage,
        PageSize: that.pagesize,
        OrderByFileds: 'Id desc',
        Category: that.Category
      }
      this.$api.post("/Download/list", params, r => {
        that.downloadlist = r.response.data;
        that.total = r.response.dataCount;
        that.isShow = false;
      });
    },
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange (size) {
      console.log(size,'size');
      this.pagesize = size;
      this.getData();
    },
    handleCurrentChange (currentPage) {
        console.log(currentPage,'currentPage');
      this.currentPage = currentPage;
      this.getData();
    },
    tableshow(item){
      var that = this;
      that.Category = item.Word_Value;
      that.getData();
      return false;
    },
    Down(id){
      window.open("http://localhost:9291/api/Download/"+id);      
    }
  },
  computed: {
    
  }
};
</script>

<style>
.ml-border{
  margin-left: 20px;
  width:100%; 
  height: 750px;
  border: 1px solid #CCCCCC;
}
.frame-border{
  width: 204px;  
  border: 1px solid #EEEEEE;
}
.lmenu{
  display: flex;
  justify-content: space-between;
  align-items: center;
  color:#222222;
  font-size: 18px;
}
.pagination{
  text-align: center;
}
</style>